export interface StringList {
  COM_XCM_READ_MORE: string;
}

interface Langs {
  ru: StringList;
  en: StringList;
  pl: StringList;
  fa: StringList;
  uz: StringList;
 kk: StringList;
 ko: StringList;
}

export const languages = <Langs>{
  ru: <StringList>{
    COM_XCM_READ_MORE: 'читать полностью'
  },
  en: <StringList>{
    COM_XCM_READ_MORE: 'Read more'
  },
  pl: <StringList>{
    COM_XCM_READ_MORE: 'Czytaj więcej'
  },
  fa: <StringList>{
    COM_XCM_READ_MORE: 'بیشتر بخوانید'
  },
  uz: <StringList>{
    COM_XCM_READ_MORE: 'TO\'LIQ O\'QISh'
  }
}